module.exports = __webpack_public_path__ + "media/images/front/brands/creations/creations_2-36f7175294c4a891146c3246079bc5f3.jpg";